import React from "react";
import { Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {LanguageHeader} from "../../components/LanguageHeader/index"

import NotFoundImg from "./icons/NotFoundImg.svg";

const { Title, Text } = Typography;

const NotFoundPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            <LanguageHeader/>
        <div className="min-h-screen bg-bgPage flex flex-col items-center justify-center px-4">
            <div className="flex flex-col items-center gap-6">
                <img
                    src={NotFoundImg}
                    alt={t("notFound.illustrationAlt") || "404 illustration"}
                    className="w-[450px] max-w-[80vw] h-auto select-none"
                    draggable="false"
                />

                <Title level={3} className="!m-0 !font-bold" style={{color: '#8932F6'}} >
                    {t("errors.notFound") || "Oops! Nothing to see here"}
                </Title>

                <Button
                    type="primary"
                    size="large"
                    shape="round"
                    icon={<ArrowLeftOutlined />}
                    className="px-6 bg-brand border-brand"
                    onClick={() => navigate("/")}
                >
                    {t("navigations.backHome") || "Back to Home"}
                </Button>

                <Text type="secondary" className="mt-10">
                    {t("signup.copyrights") || "© 2025 IMEAN Copyrights Reserved"}
                </Text>
            </div>
        </div>
        </>
    );
};

export default NotFoundPage;
